import { index } from "./components/index";

index();